import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/NotFoundPage.css";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">{t("notFound.title")}</h1>
        <h2 className="not-found-subtitle">
          {t("notFound.subtitle").toUpperCase()}
        </h2>
        <p className="not-found-description">{t("notFound.description")}</p>
        <Link to="/" className="not-found-btn">
          {t("notFound.backHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
